import { render, staticRenderFns } from "./PdfDownload.vue?vue&type=template&id=116badd3&scoped=true"
import script from "./PdfDownload.vue?vue&type=script&lang=js"
export * from "./PdfDownload.vue?vue&type=script&lang=js"
import style0 from "./PdfDownload.vue?vue&type=style&index=0&id=116badd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116badd3",
  null
  
)

export default component.exports